import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CvFilterModel, LogicalOperator, QueryOperator, ValuesType } from '../../models/filter-model';
import { FilterViewModel } from '../../models/view-model';
import * as events from 'events';
import { FilterControlService } from '../../service/filter-control.service';
import { FormGroup } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { BranchDto } from '../../../../services/api-client/models/branch-dto';
import { Sorting } from '../../../../shared/sorting';
import { SkillDto } from '../../../../services/api-client/models/skill-dto';
import { SearchCriteriaEnum } from 'src/app/shared/enums/searchCriteria';
import { GreybeeRoles } from 'src/app/shared/enums/greybeeRoles.model';
import { TranslateService } from '@ngx-translate/core';
import { ProjectTypeEnum } from 'src/app/shared/enums/project-type.model';
import { ProjectApproaches } from 'src/app/shared/enums/projectApproach.model';
import { RoleDto } from 'src/app/services/api-client/models/role-dto';
import { TechnologyDto } from 'src/app/services/api-client/models/technology-dto';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-search-area',
  templateUrl: './search-area.component.html',
  styleUrls: ['./search-area.component.scss']
})
export class SearchAreaComponent implements OnInit {

  @Output() onSearch: EventEmitter<CvFilterModel[]> = new EventEmitter<CvFilterModel[]>();

  @Input() skills: SkillDto = {
    branches: [],
    certificates: [{name: null, selected: true, certificateDate: null, id: null}],
    id: null,
    itCompetences: [{id: null, selected: true, name: null, percentageCompetence: 60}],
    languages: [{id: null, selected: true, name: null, languageLevel: null}],
    activities: [{id: null, selected: true, name: null}],
    professionalCompetences: [{id: null, name: null, selected: true, percentageCompetence: 60}]
  };

  selectedBranches: string[] = [];
  selectedProjectTypes: string[] = [];
  selectedProjectApproaches: string[] = [];
  selectedTechnologies: string[] = [];
  selectedRoles: string[] = [];
  selectedProjectRoles: string[] = [];
  isAdvancedSearchMode = false;
  selectedItemsMap: Map<number, string[]> = new Map();
  selectedLogicalOperatorsMap: Map<number, LogicalOperator> = new Map();
  selectedUserTypes: string[] = [];

  @Input() criteriaOffer: string[] = [];

  fieldMap = new Map([
    [SearchCriteriaEnum.FIRST_NAME.toString(), 'name'],
    [SearchCriteriaEnum.LAST_NAME.toString(), 'lastname'],
    [SearchCriteriaEnum.ROLE_GREYBEE.toString(), 'userRole'],
    [SearchCriteriaEnum.BRANCH_SKILLS.toString(), 'branch'],
    [SearchCriteriaEnum.LANGUAGES_SKILLS.toString(), 'language'],
    [SearchCriteriaEnum.CERTIFICATIONS.toString(), 'certificate'],
    [SearchCriteriaEnum.IT_SKILLS.toString(), 'itCompetence'],
    [SearchCriteriaEnum.PROFESSIONAL_SKILLS.toString(), 'professionalCompetence'],
    [SearchCriteriaEnum.PROJECT_TYPE.toString(), 'projectType'],
    [SearchCriteriaEnum.PROJECT_APPROACH.toString(), 'projectApproach'],
    [SearchCriteriaEnum.CUSTOMER.toString(), 'customer'],
    [SearchCriteriaEnum.ROLE_IN_PROJECT.toString(), 'projectRole'],
    [SearchCriteriaEnum.TECHNOLOGIES.toString(), 'technology'],
    [SearchCriteriaEnum.USER_TYPE.toString(), 'userType']
  ]);

  dropDownFields: string[] = ['userRole', 'branch', 'projectType', 'projectApproach', 'projectRole', 'technology', 'userType'];
  dropDownValuesMap: Map<string, string[]> = new Map();
  userTypes = ['INTERNAL', 'EXTERNAL'];

  events = events;
  logicalOperatorValues = Object.values(LogicalOperator);

  freeTextFilterModel: FilterViewModel = new FilterViewModel('freeText', QueryOperator.EQUALS, null, LogicalOperator.AND);
  selectedSearchField: FilterViewModel = new FilterViewModel(null, QueryOperator.EQUALS, null, LogicalOperator.AND, null);

  formGroups: FormGroup[] = [(this.filterControlService.filterToFormGroup(this.selectedSearchField))];

  dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    enableCheckAll: false,
    allowSearchFilter: true,
  };

  allBranches: BranchDto[];

  @Input() set setAllBranches(branches: BranchDto[]) {
    this.allBranches = branches;
    this.dropDownValuesMap.set(this.fieldMap.get(SearchCriteriaEnum.BRANCH_SKILLS.toString()), this.getBranchNames());
  }

  projRoles: RoleDto[];

  @Input() set setProjRoles(projRoles: RoleDto[]) {
    this.projRoles = projRoles;
    this.dropDownValuesMap.set(this.fieldMap.get(SearchCriteriaEnum.ROLE_IN_PROJECT.toString()), this.getProjectRoleNames());
  }

  technologies: TechnologyDto[];

  @Input() set setTechnologies(technologies: RoleDto[]) {
    this.technologies = technologies;
    this.dropDownValuesMap.set(this.fieldMap.get(SearchCriteriaEnum.TECHNOLOGIES.toString()), this.getTechnologyName());
  }

  translatedUserRoles: string[] = [];
  translatedUserRolesMap: Map<string, string> = new Map();
  translatedProjectTypes: string[] = [];
  translatedProjectTypesMap: Map<string, string> = new Map();
  translatedProjectApproaches: string[] = [];
  translatedProjectApproachesMap: Map<string, string> = new Map();
  translatedUserTypes: string[] = [];
  translatedUserTypesMap: Map<string, string> = new Map();

  constructor(private filterControlService: FilterControlService,
              private sorting: Sorting,
              private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.allBranches.sort((b1, b2) => {
      return this.sorting.compare(b1.nameEn, b2.nameEn)
    })
    this.initDropdownValues();
  }

  initDropdownValues() {
    this.getTranslatedUserRoles();
    this.getTranslatedProjectTypes();
    this.getTranslatedProjectApproaches();
    this.getTranslatedUserTypes();
    this.dropDownValuesMap.set(this.fieldMap.get(SearchCriteriaEnum.ROLE_GREYBEE.toString()), this.translatedUserRoles);
    this.dropDownValuesMap.set(this.fieldMap.get(SearchCriteriaEnum.PROJECT_TYPE.toString()), this.translatedProjectTypes);
    this.dropDownValuesMap.set(this.fieldMap.get(SearchCriteriaEnum.PROJECT_APPROACH.toString()), this.translatedProjectApproaches);
    this.dropDownValuesMap.set(this.fieldMap.get(SearchCriteriaEnum.USER_TYPE.toString()), this.translatedUserTypes);
  }

  removeField(index: any) {
    if (index >= 0 && index < this.formGroups.length) {
      this.selectedItemsMap = this.updateMapAndShiftKeys(this.selectedItemsMap, index);
      this.selectedLogicalOperatorsMap = this.updateMapAndShiftKeys(this.selectedLogicalOperatorsMap, index);
      this.formGroups.splice(index, 1);
    }
    this.executeSearch();
  }

  private updateMapAndShiftKeys<T>(map: Map<number, T>, index: number): Map<number, T> {
    map.delete(index);

    const newMapData: Map<number, T> = new Map<number, T>();

    map.forEach((value, key) => {
      const newKey = key > index ? key - 1 : key;
      newMapData.set(newKey, value);
    });

    return newMapData;
  }

  changeMode() {
    this.isAdvancedSearchMode = !this.isAdvancedSearchMode;

    if (this.isAdvancedSearchMode) {
      this.executeSearch();
    } else {
      const cvFilterModels = []
      if (this.freeTextFilterModel?.values) {
        cvFilterModels.push(this.freeTextFilterModel);
      }
      this.onSearch.emit(cvFilterModels);
    }
  }

  onSelectedSearchField(selectedForm: FormGroup<any>): void {
    selectedForm.controls['filterType'].setValue(this.getValueType(selectedForm.value['field']));

    if (this.formGroups[this.formGroups.length - 1].controls['field']?.value) {
      this.addFilter(selectedForm.value);
    }

    let index = this.formGroups.indexOf(selectedForm);
    if (index != -1) {
      if (selectedForm.value.filterType == ValuesType.DROPDOWN) {
        this.selectedItemsMap.delete(this.formGroups.indexOf(selectedForm));
      }
      selectedForm.value.values = null;
      this.nullFilterValue(index);
    }
    this.checkIfThereAreSearchValues();
  }

  nullFilterValue(index: number): void {
    this.formGroups[index].controls['values'].patchValue(null);
  }

  addFilter(cvFilterModel: CvFilterModel): void {
    let filterViewModel = this.selectedSearchField;

    filterViewModel.cvFilterModel = cvFilterModel;
    this.formGroups.push(this.filterControlService.filterToFormGroup(filterViewModel));
  }

  processSearchValueMap(form: FormGroup<any>, event: Map<string, any>) {
    if (event !== null) {
      form.controls['values'].setValue([event.get('value')]);
      form.controls['filterType'].setValue('TEXT');
      form.controls['operator'].setValue(event.get('operator'));
      form.controls['values'].valueChanges.pipe(
        debounceTime(400)
      ).subscribe((res) => {
        this.executeSearch();
      })
    } else {
      form.controls['values'].setValue(null);
      this.checkIfThereAreSearchValues();
    }
  }

  processLogicalOperatorChanging(form, event: any) {
    this.executeSearch();
    this.selectedLogicalOperatorsMap.set(this.formGroups.indexOf(form), event);
  }

  processFreeTextSearch(event: Map<string, any>): void {
    if (event !== null && event.get('value') && event.get('operator') ) {
      this.freeTextFilterModel.values = [event.get('value')];
      this.freeTextFilterModel.operator = event.get('operator');
      this.executeSearch();
    } else {
      this.freeTextFilterModel.values = null;
      this.checkIfThereAreSearchValues();
    }
  }

  checkIfThereAreSearchValues() {
    const cvFilterModels: CvFilterModel[] = this.formGroups.map(formGroup => this.filterControlService.formGroupToFilter(formGroup).cvFilterModel);

    if (this.hasNonEmptyValues(cvFilterModels) || this.freeTextFilterModel.values) {
      this.executeSearch();
    } else {
      this.onSearch.emit(null);
    }
  }

  hasNonEmptyValues(arr: CvFilterModel[]): boolean {
    return arr.some(obj => obj.values && obj.values.length > 0);
  }

  executeSearch(): void {
    const cvFilterModels = [];
    if (this.freeTextFilterModel?.values) {
      cvFilterModels.push(this.freeTextFilterModel);
    }
    cvFilterModels.push(...this.formGroups.map(formGroup => this.filterControlService.formGroupToFilter(formGroup).cvFilterModel));

    this.onSearch.emit(cvFilterModels);
  }

  getBranchNames(): string[] {
    let branchNames: string[] = [];
    this.allBranches.forEach(branch => {
      branchNames.push(branch.name);
    })
    return branchNames;
  }

  getProjectRoleNames(): string[] {
    let projRoleNames: string[] = [];
    this.projRoles.forEach(branch => {
      projRoleNames.push(branch.name);
    })
    return projRoleNames;
  }

  getTechnologyName(): string[] {
    let technologyNames: string[] = [];
    this.technologies.forEach(branch => {
      technologyNames.push(branch.name);
    })
    return technologyNames;
  }

  getValueType(fieldName: string): ValuesType {
    if (this.dropDownFields.includes(fieldName)) {
      return ValuesType.DROPDOWN;
    } else {
      return ValuesType.TEXT;
    }
  }

  getTranslatedUserRoles() {
    let roles: string[] = Object.keys(GreybeeRoles);
    this.translatedUserRoles = [];
    roles.forEach(key => {
      this.translate.get('greybee_roles.' + key).subscribe((translation: string) => {
        this.translatedUserRoles.push(translation);
        this.translatedUserRolesMap.set(translation, key);
      });
    });
  }

  getTranslatedProjectTypes() {
    let types: string[] = Object.keys(ProjectTypeEnum);
    this.translatedProjectTypes = [];
    types.forEach(key => {
      this.translate.get('project_types.' + key).subscribe((translation: string) => {
        this.translatedProjectTypes.push(translation);
        this.translatedProjectTypesMap.set(translation, key);
      });
    });
  }

  getTranslatedProjectApproaches() {
    let approaches: string[] = Object.keys(ProjectApproaches);
    this.translatedProjectApproaches = [];
    approaches.forEach(key => {
      this.translate.get('project_approaches.' + key).subscribe((translation: string) => {
        this.translatedProjectApproaches.push(translation);
        this.translatedProjectApproachesMap.set(translation, key);
      });
    });
  }

  getTranslatedUserTypes() {
    this.translatedUserTypes = [];
    this.userTypes.forEach(key => {
      this.translate.get('user_types.' + key).subscribe((translation: string) => {
        this.translatedUserTypes.push(translation);
        this.translatedUserTypesMap.set(translation, key);
      })
    })
  }

  searchWithDropDown(form: FormGroup, translatedTargetMap: Map<string, string>, translate: boolean) {
    let translatedValues = [];

    if (translate) {
      this.selectedItemsMap.get(this.formGroups.indexOf(form))
        .forEach(value => translatedValues.push(translatedTargetMap.get(value)));
      form.controls['values'].setValue(translatedValues);
    } else {
      translatedValues = [...this.selectedItemsMap.get(this.formGroups.indexOf(form))]
    }
    form.controls['values'].setValue(translatedValues);
    form.controls['filterType'].setValue('DROPDOWN');
    form.controls['operator'].setValue(QueryOperator.EQUALS);
    this.executeSearch();
  }

  onItemSelect(form: FormGroup, value: any): void {
    this.updateSelectedItemsMapOnItemSelect(form, value);
    switch (form.controls['field'].value) {
      case this.fieldMap.get(SearchCriteriaEnum.BRANCH_SKILLS.toString()): {
        this.searchWithDropDown(form, null, false);
        break;
      }
      case this.fieldMap.get(SearchCriteriaEnum.PROJECT_TYPE.toString()): {
        this.searchWithDropDown(form, this.translatedProjectTypesMap, true);
        break;
      }
      case this.fieldMap.get(SearchCriteriaEnum.PROJECT_APPROACH.toString()): {
        this.searchWithDropDown(form, this.translatedProjectApproachesMap, true);
        break;
      }
      case this.fieldMap.get(SearchCriteriaEnum.ROLE_GREYBEE.toString()): {
        this.searchWithDropDown(form, this.translatedUserRolesMap, true);
        break;
      }
      case this.fieldMap.get(SearchCriteriaEnum.ROLE_IN_PROJECT.toString()): {
        this.searchWithDropDown(form, null, false);
        break;
      }
      case this.fieldMap.get(SearchCriteriaEnum.TECHNOLOGIES.toString()): {
        this.searchWithDropDown(form, null, false);
        break;
      }
      case this.fieldMap.get(SearchCriteriaEnum.USER_TYPE.toString()): {
        this.searchWithDropDown(form, this.translatedUserTypesMap, true);
        break;
      }
    }
  }

  onItemDeSelect(form: FormGroup, value: string): void {
    this.updateSelectedItemsMapOnItemDeSelect(form, value);
    switch (form.controls['field'].value) {
      case this.fieldMap.get(SearchCriteriaEnum.BRANCH_SKILLS.toString()): {
        this.searchWithDropDown(form, null, false);
        break;
      }
      case this.fieldMap.get(SearchCriteriaEnum.PROJECT_TYPE.toString()): {
        this.searchWithDropDown(form, this.translatedProjectTypesMap, true);
        break;
      }
      case this.fieldMap.get(SearchCriteriaEnum.PROJECT_APPROACH.toString()): {
        this.searchWithDropDown(form, this.translatedProjectApproachesMap, true);
        break;
      }
      case this.fieldMap.get(SearchCriteriaEnum.ROLE_GREYBEE.toString()): {
        this.searchWithDropDown(form, this.translatedUserRolesMap, true);
        break;
      }
      case this.fieldMap.get(SearchCriteriaEnum.ROLE_IN_PROJECT.toString()): {
        this.searchWithDropDown(form, null, false);
        break;
      }
      case this.fieldMap.get(SearchCriteriaEnum.TECHNOLOGIES.toString()): {
        this.searchWithDropDown(form, null, false);
        break;
      }
      case this.fieldMap.get(SearchCriteriaEnum.USER_TYPE.toString()): {
        this.searchWithDropDown(form, this.translatedUserTypesMap, true);
        break;
      }
    }
    this.checkIfThereAreSearchValues();
  }

  private updateSelectedItemsMapOnItemSelect(form: FormGroup<any>, targetValue: string) {
    let selectedValues = this.selectedItemsMap.get(this.formGroups.indexOf(form));
    if (!selectedValues) {
      selectedValues = [];
    }
    selectedValues.push(targetValue);
    this.selectedItemsMap.set(this.formGroups.indexOf(form), selectedValues);
  }

  private updateSelectedItemsMapOnItemDeSelect(form: FormGroup<any>, targetValue: string) {
    let selectedValues = this.selectedItemsMap.get(this.formGroups.indexOf(form));
    selectedValues.forEach((item, index) => {
      if (item === targetValue)
        selectedValues.splice(index, 1);
    })
    this.selectedItemsMap.set(this.formGroups.indexOf(form), selectedValues);
  }
}
